import type {FileExtension} from 'qr-code-styling'

export interface QrDownloadFormat {
  extension: FileExtension
  label: string
  fileExt: string
}

export const QR_DOWNLOAD_FORMATS: readonly QrDownloadFormat[] = [
  {extension: 'png', label: 'PNG', fileExt: 'png'},
  {extension: 'jpeg', label: 'JPG', fileExt: 'jpg'},
  {extension: 'webp', label: 'WEBP', fileExt: 'webp'},
  {extension: 'svg', label: 'SVG', fileExt: 'svg'},
]
